var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.3673 5.27316L12.3673 10.5232C10.5473 11.2232 9.33398 12.9498 9.33398 14.9098V25.8765C9.33398 37.1465 16.6373 47.7398 26.6707 50.9598C27.534 51.2398 28.4673 51.2398 29.3307 50.9598C39.364 47.7398 46.6673 37.1698 46.6673 25.8765V14.9098C46.6657 13.9603 46.3744 13.0339 45.8324 12.2542C45.2904 11.4746 44.5235 10.8788 43.634 10.5465L29.634 5.29649C28.584 4.87649 27.4173 4.87649 26.3673 5.27316Z",
    fill: "#082567"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundShield);
export default __webpack_public_path__ + "static/media/round-shield.a5be72c8b3b4b46fa74b9b08b9b7d8a2.svg";
export { ForwardRef as ReactComponent };